module.exports = __webpack_public_path__ + "static/media/3.c05e0171.png";